import TextAnimation from '@/components/organisms/textAnimation'
import Container from '@/components/templates/container'
import toPlainText from '@/utils/toPlainText'
import { useMediaQuery } from '@mui/material'
import { useInView } from 'react-intersection-observer'

const Quote = ({ quote }) => {
  const isMobile = useMediaQuery('(max-width:767px)')
  const { ref, inView } = useInView({
    /* Optional options */
    triggerOnce: true,
  })

  const base =
    'text-olive text-displayMobile md:text-displayDesktop font-ttDrugsTrial'

  return (
    <Container ref={ref} className={base}>
      {!isMobile && (
        <TextAnimation
          inView={inView}
          outerClassName="w-full"
          className="w-full text-displayMobile md:text-displayDesktop font-ttDrugsTrial"
        >
          {toPlainText('primary',quote)}
        </TextAnimation>
      )}
      {isMobile && (
        <TextAnimation
          inView={inView}
          center
          outerClassName="w-full"
          className="w-full text-displayMobile md:text-displayDesktop font-ttDrugsTrial"
        >
          {toPlainText('primary',quote)}
        </TextAnimation>
      )}
    </Container>
  )
}

export default Quote
